import { DateTime } from 'luxon';
import { SubjectAnpr } from 'shell/models/act-category-list';
import { stateValueCitizen } from 'shell/utils/state-value-citizen';
import { CitizenFormType } from 'subscription/view-models/common-interface-subscription';

export const transformCitizen = (
  intestatario: SubjectAnpr,
  padre?: SubjectAnpr,
  madre?: SubjectAnpr
): CitizenFormType => {
  return {
    state: stateValueCitizen(padre, madre),
    validity: intestatario.dataNascita ? DateTime.fromISO(intestatario.dataNascita) : null,
  };
};
